function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/image/imagetypecommand
 */
import { Command } from 'ckeditor5/src/core';
/**
 * The image type command. It changes the type of a selected image, depending on the configuration.
 *
 * @extends module:core/command~Command
 */

var ImageTypeCommand = /*#__PURE__*/function (_Command) {
  _inherits(ImageTypeCommand, _Command);

  var _super = _createSuper(ImageTypeCommand);

  /**
   * @inheritDoc
   *
   * @param {module:core/editor/editor~Editor} editor
   * @param {'imageBlock'|'imageInline'} modelElementName Model element name the command converts to.
   */
  function ImageTypeCommand(editor, modelElementName) {
    var _this;

    _classCallCheck(this, ImageTypeCommand);

    _this = _super.call(this, editor);
    /**
     * Model element name the command converts to.
     *
     * @readonly
     * @private
     * @member {'imageBlock'|'imageInline'}
     */

    _this._modelElementName = modelElementName;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ImageTypeCommand, [{
    key: "refresh",
    value: function refresh() {
      var editor = this.editor;
      var imageUtils = editor.plugins.get('ImageUtils');
      var element = imageUtils.getClosestSelectedImageElement(this.editor.model.document.selection);

      if (this._modelElementName === 'imageBlock') {
        this.isEnabled = imageUtils.isInlineImage(element);
      } else {
        this.isEnabled = imageUtils.isBlockImage(element);
      }
    }
    /**
     * Executes the command and changes the type of a selected image.
     *
     * @fires execute
     * @returns {Object|null} An object containing references to old and new model image elements
     * (for before and after the change) so external integrations can hook into the decorated
     * `execute` event and handle this change. `null` if the type change failed.
     */

  }, {
    key: "execute",
    value: function execute() {
      var _this2 = this;

      var editor = this.editor;
      var model = this.editor.model;
      var imageUtils = editor.plugins.get('ImageUtils');
      var oldElement = imageUtils.getClosestSelectedImageElement(model.document.selection);
      var attributes = Object.fromEntries(oldElement.getAttributes()); // Don't change image type if "src" is missing (a broken image), unless there's "uploadId" set.
      // This state may happen during image upload (before it finishes) and it should be possible to change type
      // of the image in the meantime.

      if (!attributes.src && !attributes.uploadId) {
        return null;
      }

      return model.change(function (writer) {
        // Get all markers that contain the old image element.
        var markers = Array.from(model.markers).filter(function (marker) {
          return marker.getRange().containsItem(oldElement);
        });
        var newElement = imageUtils.insertImage(attributes, model.createSelection(oldElement, 'on'), _this2._modelElementName);

        if (!newElement) {
          return null;
        }

        var newElementRange = writer.createRangeOn(newElement); // Expand the previously intersecting markers' ranges to include the new image element.

        var _iterator = _createForOfIteratorHelper(markers),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var marker = _step.value;
            var markerRange = marker.getRange(); // Join the survived part of the old marker range with the new element range
            // (loosely because there could be some new paragraph or the existing one might got split).

            var range = markerRange.root.rootName != '$graveyard' ? markerRange.getJoined(newElementRange, true) : newElementRange;
            writer.updateMarker(marker, {
              range: range
            });
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return {
          oldElement: oldElement,
          newElement: newElement
        };
      });
    }
  }]);

  return ImageTypeCommand;
}(Command);

export { ImageTypeCommand as default };